export default __webpack_public_path__ + "static/media/menu-meus-dados.e719c830.svg";